import Axios from "axios";
import { SubmitButton } from "Components/Button";
import { Horizontal } from "Components/Horizontal";
import { LcpUserPageWrapper } from "Components/MainPageWrapper";
import { Section } from "Components/Section";
import { EnterKeyCatcher } from "Inputs/EnterKeyCatcher";
import { useFormWithSchema } from "Inputs/FormTools";
import { Textbox } from "Inputs/Textbox";
import { YupDefined } from "Inputs/Tools";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { serverConstants } from "Shared/Constants";
import { hasValue } from "Tools";
import * as Yup from "yup";
import { PublicPaths } from "./Paths";

export function useComponentFormik(props: {
  setSubmitSuccessful: (value: boolean) => void;
}) {
  return useFormWithSchema({
    initialValues: { email: null },
    onSubmit: async (values, handlers) => {
      const result = await Axios.post("/api/User/ForgotPassword", values);
      if (hasValue(result.data.errors)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        handlers.setErrors(result.data.errors);
        return;
      }
      props.setSubmitSuccessful(true);
    },
    validationSchema: Yup.object({
      email: YupDefined.string()
        .nullable()
        .label("Email")
        .email("Please enter a valid email.")
        .required(),
    }),
  });
}

export function ForgotPasswordPage() {
  const [isSubmitSuccessful, setSubmitSuccessful] = useState(false);
  const formik = useComponentFormik({ setSubmitSuccessful });
  if (isSubmitSuccessful) {
    return (
      <LcpUserPageWrapper documentTitle="Password Assistance">
        <Section title="Password Assistance" className="narrowFieldBodies3">
          <em>
            An email with a link to reset your password has been sent to{" "}
            {formik.values.email}.
          </em>
          <div className="has-text-centered" style={{ marginTop: "1em" }}>
            <Link to={PublicPaths.LogIn}>Return to Log In</Link>
          </div>
        </Section>
      </LcpUserPageWrapper>
    );
  }
  return (
    <LcpUserPageWrapper documentTitle="Password Assistance">
      <Section title="Password Assistance" className="narrowFieldBodies3">
        <div style={{ marginBottom: "2em" }}>
          <em>
            Enter the email address associated with your{" "}
            {serverConstants.CompanyName} account. You will receive a link to
            create a new password via email.
          </em>
        </div>
        <EnterKeyCatcher handleSubmit={formik.handleSubmit}>
          <Horizontal label="Email" isRequired>
            <Textbox
              type="email"
              fieldProps={formik.field.getSubField("email")}
              placeholder={`name@${serverConstants.StaticSiteHost}`}
              style={{ flexGrow: 1 }}
            />
          </Horizontal>
          <div className="has-text-centered" style={{ marginTop: "1em" }}>
            <SubmitButton
              isSubmitting={formik.isSubmitting}
              onClick={formik.submitForm}
            >
              Send Password Reset Email
            </SubmitButton>
          </div>
          <div className="has-text-centered" style={{ marginTop: "1em" }}>
            <Link to={PublicPaths.LogIn}>Return to Log In</Link>
          </div>
        </EnterKeyCatcher>
      </Section>
    </LcpUserPageWrapper>
  );
}
